import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar.component';
import { TranslateModule } from '@ngx-translate/core';
import { ElementsModule } from '@shared/elements/elements.module';
import { StateRefDirectiveModule } from '@shared/directives/state-ref/state-ref.directive.module';
import { AvatarComponentModule } from '@components/avatar/avatar-component.module';
import { PopComponentModule } from '@components/pop/pop.component.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { CompanySelectorComponent } from './company-selector/company-selector.component';
import { LoaderComponentModule } from '@components/loader/loader.module';

@NgModule({
    declarations: [
        NavBarComponent,
        CompanySelectorComponent
    ],
    imports: [
      CommonModule,
      TranslateModule,
      ElementsModule,
      StateRefDirectiveModule,
      AvatarComponentModule,
      PopComponentModule,
      DirectivesModule,
      LoaderComponentModule
    ],
    exports: [
        NavBarComponent,
        CompanySelectorComponent
    ],
    providers: [
    ]
})
export class NavBarComponentModule {}